
 

 

 

 
class MenuParameter 
{
    
        Root: string;
    
        IsShowAll: boolean;
    
}
 
export default MenuParameter;
 




